import { LitElement, html, css } from 'lit';
import './outline_button';
import './modal';
import './cancel_button'
import './orange_button';

class ProposeLoginModal extends LitElement {
  static properties = {
    isModalOpen: { type: Boolean, reflect: true },
    isLogin: { type: Boolean, reflect: true },
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.isModalOpen = false;
  } 
  updated(changedProperties) {
    
  }
  static styles = css`
  .description {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 23px;
    .orange-mark {
      color: #D76315;
      font-weight: 700;
    }
  }
  .notice {
    display: flex;
    color: #A8ABA6;
    gap: 4px;
    font-family: "Noto Sans JP";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 32px;
  }
  .upgrade-button {
    margin-bottom: 32px;
    a {
      text-decoration: none;
    }
  }
  .supporter-link {
    margin-bottom: 24px;
  }
  .cancel-button {
    display: flex;
    justify-content: end;
  }
  a {
    color: #00818F;
  }
  .annotation-char {
    vertical-align: super;
    font-size: 8px;
  }
  `
  close() {
    this.dispatchEvent(new CustomEvent('close'));
  }
  render() {
    return html`
      <modal-template
        @close="${this.close}"
        .isOpen="${this.isModalOpen}"
      >
        <div slot="header">
          <div>スポレボPlusに登録して</div>
          <div>空き状況の通知を受け取りませんか?</div>
        </div>
        <div slot="content">
          <div class="description">
            スポレボPlusにご登録いただくと、特定のスポーツ施設<span class="annotation-char">※</span>の<span class="orange-mark">「利用・予約可能な空き枠がある日時」を自動で通知</span>することができます。
            <br>
            <br>
            その他、各スポーツ施設の空き状況<span class="annotation-char">※</span>（カレンダー）が<span class="orange-mark">最大1ヶ月先まで</span>閲覧可能に！
          </div>
          <div class="notice">
            <div>※</div>
            <div>
              スポレボ内に掲載されている施設、かつ空き状況の取得が可能なものに限ります。取得状況は鋭意拡大中ですので、利用したい施設が対応しているか事前にご確認いただけますようお願いいたします。また現在未取得の施設でも、施設ページから空き状況の取得リクエストを受け付けております。お気軽にリクエストください。
            </div>
          </div>
          <div class="upgrade-button">
            <a href="/order_confirm">
              <orange-button isDisplayRightArrow="true" class="upgrade-button">
                スポレボPlusを無料で試してみる
              </orange-button>
            </a>
          </div>
          <div class="supporter-link">
            <a href="/login">ご登録済みの方はこちらからログイン</a>
          </div>
          <div class="supporter-link">
            <a href="/about_sporevo_plus" target="_blank">スポレボPlusをもっと詳しく知る</a>
          </div>
          <div class="cancel-button">
            <cancel-button
              @click="${this.close}"
            >キャンセル</cancel-button>
          </div>
        </div>
      </modal-template>
    `;
  }
}
customElements.define('propose-login-modal', ProposeLoginModal);